import { render, staticRenderFns } from "./DemandList.vue?vue&type=template&id=02a79b98&scoped=true"
import script from "./DemandList.vue?vue&type=script&lang=js"
export * from "./DemandList.vue?vue&type=script&lang=js"
import style0 from "./DemandList.vue?vue&type=style&index=0&id=02a79b98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a79b98",
  null
  
)

export default component.exports